import { useIntl } from 'react-intl';

export function Tr() {
  const intl = useIntl();
  return (id: string) => intl.formatMessage({ id, defaultMessage: id });
}
// translated toolbar/agenda labels for react-big-calendar (it falls back to english otherwise)
export function calendarMessages(t: (id: string) => string) {
  return {
    today: t('Today'),
    previous: t('Back'),
    next: t('Next'),
    month: t('Month'),
    week: t('Week'),
    day: t('Day'),
    agenda: t('Agenda'),
    date: t('Date'),
    time: t('Time'),
    event: t('Event'),
    allDay: t('All Day'),
    noEventsInRange: t('No events in this range.'),
    showMore: (total: number) => `+${total} ${t('more')}`,
  }
}
